module.exports = "/images/Login-03-01.png?d74e560d86ea931916bcf7f875a009be";